import { useDismissFOIModalMilestones } from "@faire/deprecated-retailer-visitor-shared/hooks/firstOrderIncentive/useDismissFOIModalMilestones";
import { isFOIModalE2E } from "@faire/deprecated-retailer-visitor-shared/lib/isFOIModalE2E";
import { useSettingPersonalizedFoiV2 } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingPersonalizedFoiV2";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { isE2E } from "@faire/web/common/user-agent/isE2E";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";

export const useFirstOrderIncentiveGate: IGateHook = () => {
  const modalType = useModalType();
  const {
    foiModalDismissCount,
    lastChanceFoiModalDismissCount,
    autoExtendFoiModalDismissCount,
  } = useDismissFOIModalMilestones();

  const personalizedFoiV2 = useSettingPersonalizedFoiV2();

  const hasDismissedFoiModal =
    foiModalDismissCount >= 1 ||
    lastChanceFoiModalDismissCount >= 1 ||
    autoExtendFoiModalDismissCount >= 1;

  if (isE2E() && !isFOIModalE2E()) {
    return undefined;
  }

  if (personalizedFoiV2 && hasDismissedFoiModal) {
    return undefined;
  }

  return modalType === PromoModalType.FIRST_ORDER_INCENTIVE_MODAL
    ? PromoModalType.FIRST_ORDER_INCENTIVE_MODAL
    : undefined;
};
